(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-product-grid"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        if (typeof jQuery !== 'undefined' && jQuery.fn.mCustomScrollbar) {
            jQuery('.content-scrollBar,.cusscroll').mCustomScrollbar();
        } else {
            console.error('mCustomScrollbar not loaded');
        }
    });

    function getChatHistory() {
      return JSON.parse(localStorage.getItem('ai_chat_history')) || [];
    }

    function clearChatHistory() {
     localStorage.removeItem('ai_chat_history');
    }


    function saveChatMessage(query, aiResponse, showButton = false) {
        const history = getChatHistory();

        history.push({
            query: query,
            aiResponse: aiResponse,
            showButton: showButton,
            timestamp: Date.now()
        });

        localStorage.setItem('ai_chat_history', JSON.stringify(history));
        }



    const client = algoliasearch('14P172JBE8', '069d613ebbadb5e305e9c9a6dbec4262');
    const index = client.initIndex('shopify_products');

    // function cleanQuery(query) {
    //     return query
    //     .replace(/looking for|i am|need|want/gi, '')
    //     .trim();
    // }

    function cleanQuery(q) {
    return q
        .toLowerCase()
        .replace(/i am looking for|show me|find|search|please/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    
    const pm_main_sel = document.querySelector('.cs-pg-product-cards');
    const chatMessageMainSel = document.querySelector('.chat-messages-wrapper');

    const genrateItemHTML = (pructs, message, lastQuery) => {



        const uniqueByTitle = Object.values(
            pructs.reduce((acc, item) => {
                if (!acc[item.title]) {
                acc[item.title] = item;
                }
                return acc;
            }, {})
        );


        let products = uniqueByTitle;

        if (lastQuery) {

            const filteredProducts = products.filter(item =>
              item.title?.toLowerCase().includes(lastQuery.trim().toLowerCase())
            );

            // ✅ Reassign ONLY if exactly one match found
            if (filteredProducts.length === 1) {
                products = filteredProducts;
            }

            console.log('products', products);
        }
         
         
         let itemsHTML = '';
         products.forEach((product, index) => {

           const top_metch_html = `
            <div class="best-match-info">
                <div class="bm-content">
                    <div class="bm-title">Best Match for Your Laptop</div>
                    <div class="bm-text">Based on your model search</div>
                </div>
                <div class="bm-icon">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_186_96)">
                        <path d="M11.5 0C5.15703 0 0 5.15703 0 11.5C0 17.843 5.15703 23 11.5 23C17.843 23 23 17.843 23 11.5C23 5.15703 17.843 0 11.5 0ZM11.5 21.5625C5.95215 21.5625 1.4375 17.0479 1.4375 11.5C1.4375 5.95215 5.95215 1.4375 11.5 1.4375C17.0479 1.4375 21.5625 5.95215 21.5625 11.5C21.5625 17.0479 17.0479 21.5625 11.5 21.5625ZM17.0613 7.62324C17.3398 7.90176 17.3398 8.35996 17.0613 8.63848L10.323 15.3768C10.1838 15.516 9.99961 15.5879 9.81543 15.5879C9.63125 15.5879 9.44707 15.516 9.30781 15.3768L5.93867 12.0076C5.66016 11.7291 5.66016 11.2709 5.93867 10.9924C6.21719 10.7139 6.67539 10.7139 6.95391 10.9924L9.81543 13.8539L16.0461 7.62324C16.3246 7.34023 16.7828 7.34023 17.0613 7.62324Z" fill="#00FFDD"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_186_96"><rect width="23" height="23" fill="white"/></clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            `;

            const varifyed_label_html = `
              <div class="cam_verified">
                <span class="icon">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_186_96)">
                    <path d="M11.5 0C5.15703 0 0 5.15703 0 11.5C0 17.843 5.15703 23 11.5 23C17.843 23 23 17.843 23 11.5C23 5.15703 17.843 0 11.5 0ZM11.5 21.5625C5.95215 21.5625 1.4375 17.0479 1.4375 11.5C1.4375 5.95215 5.95215 1.4375 11.5 1.4375C17.0479 1.4375 21.5625 5.95215 21.5625 11.5C21.5625 17.0479 17.0479 21.5625 11.5 21.5625ZM17.0613 7.62324C17.3398 7.90176 17.3398 8.35996 17.0613 8.63848L10.323 15.3768C10.1838 15.516 9.99961 15.5879 9.81543 15.5879C9.63125 15.5879 9.44707 15.516 9.30781 15.3768L5.93867 12.0076C5.66016 11.7291 5.66016 11.2709 5.93867 10.9924C6.21719 10.7139 6.67539 10.7139 6.95391 10.9924L9.81543 13.8539L16.0461 7.62324C16.3246 7.34023 16.7828 7.34023 17.0613 7.62324Z" fill="#00FFDD"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_186_96"><rect width="23" height="23" fill="white"/></clipPath>
                    </defs>
                </svg>
                </span> Verified Compatible</div>
            `;

            const free_shipping_badge = `
                 <div class="free-shipping">
                    <span class="icon">
                        <svg width="26" height="15" viewBox="0 0 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0693 0.149307C20.2668 0.659208 21.1075 1.94421 22.1614 3.71287H18.0693V0.149307ZM5.22663 3.86139C5.65693 3.86139 5.96921 4.06906 5.96921 4.55446C5.96921 4.96386 5.63797 5.29589 5.22876 5.29703H0.742574C0.332426 5.29703 0 5.62965 0 6.0396C0 6.44975 0.332426 6.78218 0.742574 6.78218H7.42574C7.83975 6.78218 8.17124 7.11436 8.17124 7.52475C8.17124 7.9349 7.83881 8.26733 7.42866 8.26733H0.742574C0.332426 8.26733 0 8.59975 0 9.0099C0 9.42005 0.332426 9.75248 0.742574 9.75248H2.37624V11.9802C2.37624 12.3903 2.70866 12.7228 3.11881 12.7228H4.61149C4.87757 14.0335 6.03574 15 7.40099 15C8.76624 15 9.92441 14.0335 10.1905 12.7228H17.7303C17.9964 14.0335 19.1546 15 20.5198 15C21.885 15 23.0432 14.0335 23.3093 12.7228H24.604C25.0141 12.7228 25.3465 12.3903 25.3465 11.9802V7.52475C25.3465 5.34594 23.0484 5.20129 23.0463 5.19802H17.3267C16.9166 5.19802 16.5842 4.86559 16.5842 4.45545V0H3.11881C2.70866 0 2.37624 0.332426 2.37624 0.742574V2.37624H1.48515C1.075 2.37624 0.742574 2.70866 0.742574 3.11881C0.742574 3.52896 1.075 3.86139 1.48515 3.86139H5.22663ZM21.4824 11.1908C22.0141 11.7224 22.0141 12.5847 21.4824 13.1163C20.6273 13.9714 19.1584 13.3631 19.1584 12.1535C19.1584 10.9441 20.6273 10.3357 21.4824 11.1908ZM8.36361 11.1908C8.89525 11.7224 8.89525 12.5847 8.36361 13.1163C7.50852 13.9714 6.0396 13.3631 6.0396 12.1535C6.0396 10.9441 7.50852 10.3357 8.36361 11.1908Z" fill="#00FFDD"/>
                        </svg>
                    </span> Fast Free Shipping</div>
                `;
            
            const compatibility_compleated = `
                <div class="compatibility">
                    <span class="icon">
                        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.93574 0.270535C7.00384 0.192381 7.08668 0.12842 7.17952 0.0823103C7.27237 0.0362009 7.37339 0.00884808 7.47681 0.00181644C7.58024 -0.00521521 7.68403 0.00821253 7.78226 0.0413311C7.88049 0.0744496 7.97123 0.126609 8.04928 0.194826L12.8736 4.40085C12.9584 4.47488 13.0264 4.56619 13.0729 4.66867C13.1195 4.77114 13.1436 4.88239 13.1436 4.99495C13.1436 5.10751 13.1195 5.21877 13.0729 5.32124C13.0264 5.42371 12.9584 5.51503 12.8736 5.58905L8.04928 9.79508C7.97164 9.86561 7.88071 9.91995 7.78182 9.95491C7.68292 9.98987 7.57804 10.0047 7.47332 9.99868C7.3686 9.9926 7.26615 9.9657 7.17195 9.91955C7.07776 9.87339 6.99372 9.8089 6.92476 9.72987C6.85579 9.65083 6.80329 9.55883 6.77032 9.45925C6.73735 9.35967 6.72457 9.25452 6.73274 9.14994C6.74091 9.04537 6.76987 8.94347 6.8179 8.85022C6.86594 8.75697 6.93209 8.67424 7.0125 8.60688L10.2511 5.78358H0.78863C0.579472 5.78358 0.378881 5.70049 0.230984 5.5526C0.0830874 5.4047 0 5.20411 0 4.99495C0 4.7858 0.0830874 4.5852 0.230984 4.43731C0.378881 4.28941 0.579472 4.20632 0.78863 4.20632H10.2501L7.01145 1.38303C6.85392 1.24552 6.75745 1.05108 6.74325 0.842457C6.72905 0.633836 6.79829 0.428118 6.93574 0.270535Z" fill="#00FFDD"/>
                        </svg>
                    </span> Compatibility varies-verify</div>
                `;

            const compatibility_search = `
                <div class="compatibility csearch" data-title="${product.title}">
                    <span class="icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_186_115)">
                        <path d="M15.8484 15.1295L11.7175 11.0646C12.7993 9.8893 13.4639 8.33495 13.4639 6.62454C13.4634 2.96568 10.4497 0 6.73182 0C3.01395 0 0.000244141 2.96568 0.000244141 6.62454C0.000244141 10.2834 3.01395 13.2491 6.73182 13.2491C8.3382 13.2491 9.81154 12.6935 10.9688 11.7697L15.1158 15.8507C15.3179 16.0497 15.6459 16.0497 15.848 15.8507C15.896 15.8038 15.9342 15.7477 15.9603 15.6858C15.9864 15.6239 15.9999 15.5574 15.9999 15.4902C16 15.423 15.9866 15.3565 15.9606 15.2946C15.9346 15.2326 15.8964 15.1765 15.8484 15.1295ZM6.73182 12.2299C3.58609 12.2299 1.03599 9.72028 1.03599 6.62454C1.03599 3.5288 3.58609 1.01923 6.73182 1.01923C9.87757 1.01923 12.4276 3.5288 12.4276 6.62454C12.4276 9.72028 9.87757 12.2299 6.73182 12.2299Z" fill="white"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_186_115">
                        <rect width="16" height="16" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                    </span> Compatibility varies-verify</div>
                `;

           itemsHTML += `
           <div class="custom-product-card${ index == 0 ? ' first-card': ''}">
                 ${ index == 0 ? top_metch_html : '' }
                <div class="cpg-image-content-wrap">
                    <div class="cpg-image-wrap">
                       <img src="${product.product_image}" alt="${product.title}" class="icon mCS_img_loaded" />
                    </div>
                    <div class="cpg-content-wrap">
                        <h4 class="cpg-title">${product.title}</h4>
                        ${ index == 0 ? varifyed_label_html : '' }
                        <div class="cpg-price">$${product.price}</div>
                        ${ index == 0 ? free_shipping_badge : '' }
                        <a href="/products/${product.handle}" class="button">View Details 
                            <span class="icon">
                                 <svg width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M20.4086 4.42915L20.4079 4.42839L16.194 0.234836C15.8784 -0.0793172 15.3678 -0.0781481 15.0535 0.237578C14.7393 0.553264 14.7405 1.06387 15.0562 1.37806L17.8854 4.19355H0.806452C0.361049 4.19355 0 4.5546 0 5C0 5.4454 0.361049 5.80645 0.806452 5.80645H17.8854L15.0563 8.62194C14.7406 8.93613 14.7394 9.44674 15.0536 9.76242C15.3678 10.0782 15.8784 10.0793 16.1941 9.76516L20.408 5.57161L20.4087 5.57085C20.7245 5.25561 20.7235 4.74335 20.4086 4.42915Z" fill="white"/>
                                </svg>
                            </span>
                        </a>
                        
                    </div>
                </div>
                </div>
             `;
         });
         
         if(itemsHTML == ''){
            itemsHTML = `
             <div class="no-item-found">
                <p><strong>No products found</strong> ${message}</p>
             </div>
            `;
         }
         
         if(pm_main_sel){
            pm_main_sel.innerHTML = itemsHTML;
            setTimeout(() => {
                pm_main_sel.classList.remove('loading');
            }, 100);

            document.querySelectorAll('.cs-pg-product-cards .compatibility.csearch').forEach(compatibility => {
                compatibility.addEventListener('click', function () {
                    const query = compatibility.dataset.title;
                    console.log('query ',query);
                    getSearchItems(query);
                });
            });
            
         }
    }

    const getSearchItems = async (query, ai = true) => {
        pm_main_sel.classList.add('loading');

        addUserQuestion(query);

        const response = await fetch("https://lcd-bros-ai-search.fly.dev/api/aisearch", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({"query": query, 'ai': ai}),
        });

        const responseJson = await response.json();
        console.log('responseJson ',responseJson);
        if(responseJson.status == 'Success'){
           genrateItemHTML(responseJson.hits, responseJson?.aiResponse, query);
           if(ai){
            addUserQuestion(responseJson?.aiResponse, type="ai");
            saveChatMessage(query, responseJson?.aiResponse, true);
          }
        }else{
            pm_main_sel.classList.remove('loading');
        }
    }

    async function searchProducts(query) {
        if (!query) return;
        
        pm_main_sel.classList.add('loading');
        
        try {
            const result = await index.search(cleanQuery(query), {
                hitsPerPage: 10,
            });

            console.log('Algolia hits:', result.hits);

            // renderResults(result.hits);
            genrateItemHTML(result.hits);
        } catch (err) {
          console.error('Algolia error:', err);
          pm_main_sel.classList.remove('loading');
        }
    }

    const compatibilityVerify = (query) => {
     console.log('query:', query);
    };

    


    const typeWriterEffect = (element, text, speed = 25) => {
        element.innerHTML = '';
        let index = 0;

        const typingInterval = setInterval(() => {
            if (index < text.length) {
            element.innerHTML += text.charAt(index);
            index++;
            } else {
            clearInterval(typingInterval);
            }
        }, speed);
    };



    const addUserQuestion = (message, type = 'user') => {
        if (!chatMessageMainSel) return;

        if (type === 'user') {
            const newMessageHtml = `
            <div class="chat-message">
                <span class="user-message">${message}</span>
                <span class="ai-message"></span>
                <button type="button" class="ai-view-product hide" data-query="${message}">
                View Products
                </button>
            </div>
            `;
            chatMessageMainSel.insertAdjacentHTML('beforeend', newMessageHtml);
        }

        if (type === 'ai') {
            const chatMessages = chatMessageMainSel.querySelectorAll('.chat-message');
            console.log('chatMessages ',chatMessages);
            const lastMessage = chatMessages[chatMessages.length - 1];
            console.log('chatMessages ',lastMessage);
            const aiMessageEl = lastMessage.querySelector('.ai-message');
            console.log('aiMessageEl ',aiMessageEl);

            typeWriterEffect(aiMessageEl, message);
        }
    };


    document.querySelectorAll('.ai-search-form-wrap form').forEach(form => {
        form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const formData = new FormData(form);
        const jsonData = Object.fromEntries(formData.entries());

        window.scrollTo({ top: 0, behavior: 'smooth' });

        getSearchItems(jsonData.query);
        
        form.querySelector('input[name="query"]').value = '';

        // searchProducts(jsonData.query);
        
        });
    });


    const params = new URLSearchParams(window.location.search);
    const query = params.get('query');

    // console.log(query);
    if(query){
        getSearchItems(query);
        // searchProducts(query);
    }else{
        const historyChat = getChatHistory();


        if(historyChat.length > 0){
            getSearchItems(historyChat[historyChat.length - 1].query, false);
        }

        if (!chatMessageMainSel) return;
        
        let historyChatHTML = '';
        historyChat.forEach(item => {
           
           const view_product_btn_html = item.showButton ? `<button type="button" class="ai-view-product hide" data-query="${item.query}">View Products</button>`:'';
              historyChatHTML += `
                    <div class="chat-message">
                        <span class="user-message">${item.query}</span>
                        <span class="ai-message">${item.aiResponse}</span>
                    </div>
                `;
            });

        chatMessageMainSel.innerHTML = historyChatHTML;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('query');
    window.history.replaceState({}, document.title, url.pathname + url.search);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["government-schools"] && !Shopify.designMode) return;
  try {
    


  document.querySelectorAll('.gs-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const popup = document.querySelector('.organization-form-popup');
            if (popup) {
             popup.classList.add('active');
             document.querySelector('body').classList.add('overflow-hidden');
            }
        });
    });

    document.querySelectorAll('.ofp-wrapper span.close-icon').forEach(btn => {
        btn.addEventListener('click', () => {
            const popup = document.querySelector('.organization-form-popup');
            if (popup) {
                popup.classList.remove('active');
                document.querySelector('body').classList.remove('overflow-hidden')
            }
        });
    });

    document.querySelectorAll('form.organization-form').forEach(form => {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();

            // Collect form data

            const submitBtn = form.querySelector('.form-btn-wrap button');

            submitBtn.classList.add('loading');
            const formData = new FormData(form);

            // Convert FormData to a plain object
            const data = Object.fromEntries(formData.entries());

            try {
            const response = await fetch('https://lcd-bros-ai-search.fly.dev/api/po', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({ formData: data })
            });

            const result = await response.json();

            if (response.ok) {
                alert('Your form has been submitted successfully. We will reach out to you shortly.');
                submitBtn.classList.remove('loading');
                form.reset();
            } else {
                alert(result.message || 'Something went wrong. Please try again.');
                submitBtn.classList.remove('loading');
            }

            } catch (error) {
            console.error('Form submission error:', error);
            alert('Network error. Please try again later.');
            submitBtn.classList.remove('loading');
            }
        });
        });


        document.addEventListener('DOMContentLoaded', function () {
        if (typeof jQuery !== 'undefined' && jQuery.fn.mCustomScrollbar) {
            jQuery('.cusscroll').mCustomScrollbar();
        } else {
            console.error('mCustomScrollbar not loaded');
        }
    });
   
    /* js code for product details chatboat */
    document.querySelectorAll('.gs-content-wrap a').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const popup = document.querySelector('.pd-chatbot-popup');
            if (popup) {
             popup.classList.add('active');
             document.querySelector('body').classList.add('overflow-hidden');
            }
        });
    });

    document.querySelectorAll('.pd-chatbot-popup .close-icon').forEach(btn => {
        btn.addEventListener('click', () => {
            const popup = document.querySelector('.pd-chatbot-popup');
            if (popup) {
                popup.classList.remove('active');
                document.querySelector('body').classList.remove('overflow-hidden')
            }
        });
    });
   
    /* product details page ai form submit */
    document.querySelectorAll('.pd-chatbot-head-wrap form.ai-form').forEach(form => {
        form.addEventListener('submit', async function(e){
            e.preventDefault();
            
            const querySel = form.querySelector('.ai-form-row textarea');
            if(querySel.value){
               const query = querySel.value;
               querySel.value = '';

               addUserQuestion(query);
                // console.log('form data');
                const response = await fetch("https://lcd-bros-ai-search.fly.dev/api/pdchatbot", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({"productJson": productJson, "userMessage": query}),
                });

                const responseJson = await response.json();
                if(responseJson.status == 'Success'){
                  addUserQuestion(responseJson?.aiResponse, type="ai");
                }else{
                    
                }
            }
        });
    });

    const typeWriterEffect = (element, text, speed = 25) => {
        element.innerHTML = '';
        let index = 0;

        const typingInterval = setInterval(() => {
            if (index < text.length) {
            element.textContent += text.charAt(index); // IMPORTANT: textContent
            index++;
            } else {
            clearInterval(typingInterval);

            // Convert links AFTER typing finishes
            element.innerHTML = formatLinks(element.textContent);
            }
        }, speed);
    };


    const formatLinks = (text) => {
    return text.replace(
        /(https?:\/\/[^\s]+|\/collections\/[^\s]+|\/pages\/[^\s]+)/g,
        (url) => `<a href="${url}" class="chat-link">${url}</a>`
    );
    };


   
    const chatMessageMainSel = document.querySelector('#pd-chatbot-qa');

    const addUserQuestion = (message, type = 'user') => {
        if (!chatMessageMainSel) return;

        if (type === 'user') {
            const newMessageHtml = `
            <div class="chat-message">
                <span class="user-message">${message}</span>
                <span class="ai-message"></span>
            </div>
            `;
            chatMessageMainSel.insertAdjacentHTML('beforeend', newMessageHtml);
        }

        if (type === 'ai') {
            const chatMessages = chatMessageMainSel.querySelectorAll('.chat-message');
            console.log('chatMessages ',chatMessages);
            const lastMessage = chatMessages[chatMessages.length - 1];
            console.log('chatMessages ',lastMessage);
            const aiMessageEl = lastMessage.querySelector('.ai-message');
            console.log('aiMessageEl ',aiMessageEl);

            typeWriterEffect(aiMessageEl, message);
        }
    };


    document.addEventListener('DOMContentLoaded', function () {
        if (typeof jQuery !== 'undefined' && jQuery.fn.mCustomScrollbar) {
            jQuery('.cust-scroll').mCustomScrollbar();
        } else {
            console.error('mCustomScrollbar not loaded');
        }
        });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ai-search"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ai-search-block form').forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      const jsonData = Object.fromEntries(formData.entries());

      localStorage.setItem('ai_chat_history', JSON.stringify([]));

      window.location.href = `/collections/all?query=${jsonData.query}`;

      
    });
  });

  document.querySelectorAll("textarea#ai-src-input").forEach(textarea => {
    
      const form = textarea.closest(".ai-search-block form");
      textarea.addEventListener("keydown", function (e) {
          
        if (e.key === "Enter" && !e.shiftKey) {
          console.log('keydown Enter');
          e.preventDefault(); 
          form.querySelector('.ai-search__button button.ai_button').click();
        }
      });
      
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function startShippingCountdown() {
  const cutoffHour = 14; // 2 PM PT
  const shippingDays = 2;

  function getPacificTime() {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
  }

  function addBusinessDays(date, days) {
    let result = new Date(date);
    while (days > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0) days--; // Skip Sunday
    }
    return result;
  }

  function formatTimeRemaining(ms) {
    const totalMinutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let parts = [];
    if (hours > 0) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);

    return parts.join(' and ');
  }

  function updateTimer() {
    const now = getPacificTime();

    let cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    let shipsToday = true;
    if (now > cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
      shipsToday = false;
    }

    const diff = cutoff - now;

    document.getElementById('countdown').textContent = formatTimeRemaining(diff);

    let shipDate = new Date(now);
    if (!shipsToday) shipDate.setDate(shipDate.getDate() + 1);

    let deliveryDate = addBusinessDays(shipDate, shippingDays);

    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    document.getElementById('delivery-date').textContent =
      deliveryDate.toLocaleDateString('en-US', options);
  }

  updateTimer();
  setInterval(updateTimer, 60000); // Update every minute
}

startShippingCountdown();


document.querySelectorAll("product-form.product-form button.custom-gtc-btn").forEach(function(button) {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      
      const form = button.closest("form");
      const formData = new FormData(form);
      button.classList.add('loading');

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {"Accept": "application/json"}
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(data => {
        button.classList.remove('loading');
        window.location.href = "/checkout";
      })
      .catch(error => {
        let message = error?.description || error?.message || "Something went wrong while adding the product to the cart.";
        alert(message);
        button.classList.remove('loading');
      });

    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-return"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.or-wrapper .or-form-wrap form').forEach(form => {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();

            const submitBtn = form.querySelector('button');

            submitBtn.classList.add('loading');
            const formData = new FormData(form);

            // Convert FormData to a plain object
            const data = Object.fromEntries(formData.entries());

            try {
            const response = await fetch('https://lcd-bros-ai-search.fly.dev/api/order-return', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({ formData: data })
            });

            const result = await response.json();

            if (response.ok) {
                // alert('Your form has been submitted successfully. We will reach out to you shortly.');
                form.closest('.or-form-wrap').classList.add('submitted');
                submitBtn.classList.remove('loading');
                form.reset();
            } else {
                alert(result.message || 'Something went wrong. Please try again.');
                submitBtn.classList.remove('loading');
            }

            } catch (error) {
            console.error('Form submission error:', error);
            alert('Network error. Please try again later.');
            submitBtn.classList.remove('loading');
            }
        });
        });


        document.addEventListener('DOMContentLoaded', function () {
        if (typeof jQuery !== 'undefined' && jQuery.fn.mCustomScrollbar) {
            jQuery('.cusscroll').mCustomScrollbar();
        } else {
            console.error('mCustomScrollbar not loaded');
        }
    });
   

  } catch(e) { console.error(e); }
})();
})();
